import SectionHeading from '@/components/base/SectionHeading';
import { hotPicks } from '@/mocks/home';

export default function PicksSection() {
  return (
    <section id="picks" className="w-full bg-background-50 py-16 md:py-24">
      <div className="mx-auto w-full max-w-6xl px-4 md:px-8">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <SectionHeading
            eyebrow="热门话题"
            title="本周值得跟进的吃瓜话题"
            desc="我们按热度与信息增量挑出了六个话题，每一篇都整理好了时间线、关键节点和讨论脉络，可以直接照着读。"
          />
          <a
            href="#topics"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap font-label text-sm font-medium text-primary-600 transition-colors hover:text-primary-700"
          >
            按分类浏览
            <i className="ri-arrow-right-line text-base" aria-hidden="true"></i>
          </a>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 md:mt-14 sm:grid-cols-2 lg:grid-cols-3">
          {hotPicks.map((pick) => (
            <article
              key={pick.seq}
              className="group flex flex-col overflow-hidden rounded-lg border border-background-200/80 bg-background-100/50 transition-colors hover:border-primary-300/70"
            >
              <div className="relative h-48 w-full overflow-hidden md:h-52">
                <img
                  src={pick.image}
                  alt={`${pick.category}话题配图：${pick.title}`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-2.5 py-1 font-label text-xs font-medium text-background-50">
                  {pick.category}
                </span>
              </div>
              <div className="flex flex-1 flex-col p-5">
                <h3 className="font-heading text-base font-bold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700">
                  {pick.title}
                </h3>
                <p className="mt-2.5 flex-1 text-sm leading-relaxed text-foreground-600">{pick.excerpt}</p>
                <div className="mt-4 flex items-center justify-between border-t border-background-200/80 pt-3.5 font-label text-xs text-foreground-500">
                  <span className="flex items-center gap-1.5">
                    <i className="ri-calendar-line text-sm" aria-hidden="true"></i>
                    {pick.date}
                  </span>
                  <span className="flex items-center gap-1.5">
                    <i className="ri-time-line text-sm" aria-hidden="true"></i>
                    阅读 {pick.readTime}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}